import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import { Modal } from 'react-bootstrap';

import { Constants } from 'constants';

/**
 * @parent Layout.js
 */
export default class ContactModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show;
  }

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- renderers

  renderBody() {
    return (
      <div className="row contact_modal">
        <div className="col-xs-12">
          <h2 className="text-center">
            {I18n.tr('components.contact_modal.send_mail_to')}
            <br />
            <a href={`mailto:${Constants.CONTACT_EMAIL}`} target="_blank">
              {Constants.CONTACT_EMAIL}
            </a>
          </h2>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.contact_modal.title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/modal/ContactModal.js